import { createReaction } from '@/lib/server-functions/create-reaction';
import { useMutation } from '@tanstack/react-query';

type NewReaction = {
  pollId: string;
  type: 'upvote' | 'downvote';
};

export const useCreateReaction = () => {
  return useMutation({
    mutationFn: async (payload: NewReaction) => {
      await createReaction({ data: payload });
    },
  });
};
